var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSoftStar = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 59,
  height: 58,
  fill: "none"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E3EFFF",
  d: "M28.726.687c.109-.916 1.44-.916 1.548 0l.912 7.69a21.636 21.636 0 0 0 18.937 18.937l7.69.912c.916.109.916 1.44 0 1.548l-7.69.912a21.636 21.636 0 0 0-18.937 18.937l-.912 7.69c-.109.916-1.44.916-1.548 0l-.912-7.69A21.636 21.636 0 0 0 8.877 30.686l-7.69-.912c-.916-.109-.916-1.44 0-1.548l7.69-.912A21.636 21.636 0 0 0 27.814 8.377z"
})));
export { SvgSoftStar as ReactComponent };